export default __webpack_public_path__ + "static/developper-89cbb4cc2271a120463f0dee1ba7cbd4.png";